import { render } from "./InfiniteBarLoader.vue?vue&type=template&id=9ce401d2&scoped=true"
const script = {}

import "./InfiniteBarLoader.vue?vue&type=style&index=0&id=9ce401d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ce401d2"]])

export default __exports__